module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company-stastics-box fitSize"
  }, [_c('el-row', {
    staticClass: "company-stastics-wrapper fitSize"
  }, [_c('el-col', {
    staticClass: "company-stastics-item left",
    attrs: {
      "span": 13
    }
  }, [_c('header', {
    staticClass: "left-hd"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('img', {
    staticClass: "x_icon",
    attrs: {
      "src": require("../../img/ZS.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "span_size"
  }, [_vm._v("有效产品")]), _vm._v(" "), _c('span', {
    staticClass: "label_count zs"
  }, [_vm._v(_vm._s(_vm.proNum))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('img', {
    staticClass: "x_icon",
    attrs: {
      "src": require("../../img/XZ.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "span_size"
  }, [_vm._v("闲置产品")]), _vm._v(" "), _c('span', {
    staticClass: "label_count xz"
  }, [_vm._v(_vm._s(_vm.proXZ))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('img', {
    staticClass: "x_icon",
    attrs: {
      "src": require("../../img/GQ.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "span_size"
  }, [_vm._v("已过期产品")]), _vm._v(" "), _c('span', {
    staticClass: "label_count ygq"
  }, [_vm._v(_vm._s(_vm.proGQ))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('img', {
    staticClass: "x_icon",
    attrs: {
      "src": require("../../img/JGQ.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "span_size"
  }, [_vm._v("即将过期")]), _vm._v(" "), _c('span', {
    staticClass: "label_count jgq"
  }, [_vm._v(_vm._s(_vm.proJGQ))])])], 1)], 1), _vm._v(" "), _c('article', {
    staticClass: "left-bd",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('header', {
    staticClass: "module-title"
  }, [_vm._v("产品统计")]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.productLoading),
      expression: "productLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.products
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "logo",
      "header-align": "center",
      "align": "center",
      "width": "100px",
      "label": "产品图片"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "tpimg",
          attrs: {
            "slot": "reference",
            "src": scope.row.logo,
            "alt": "logo"
          },
          slot: "reference"
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "产品名称",
      "min-width": "140",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "num",
      "label": "产品数量",
      "width": "90",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unUsedSum",
      "label": "闲置产品",
      "width": "90",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dueSum",
      "label": "过期产品",
      "width": "90",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dueMonthSum",
      "label": "即将过期",
      "width": "90",
      "show-overflow-tooltip": ""
    }
  })], 1)], 1), _vm._v(" "), _c('footer', {
    staticClass: "left-ft"
  }, [_c('header', {
    staticClass: "module-title"
  }, [_vm._v("模块使用情况")]), _vm._v(" "), _c('el-select', {
    staticClass: "checkName",
    staticStyle: {
      "float": "right"
    },
    on: {
      "change": function($event) {
        return _vm.changeTime('getCompanyMonthModulePointPie')
      }
    },
    model: {
      value: (_vm.moduleTime),
      callback: function($$v) {
        _vm.moduleTime = $$v
      },
      expression: "moduleTime"
    }
  }, _vm._l((_vm.times), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.masg),
      expression: "!masg"
    }, {
      name: "loading",
      rawName: "v-loading",
      value: (_vm.moduleLoading),
      expression: "moduleLoading"
    }],
    staticClass: "pie-content"
  }, [_c('el-col', {
    staticClass: "pie-chart",
    attrs: {
      "span": 14
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "id": "echartModule"
    }
  })]), _vm._v(" "), (_vm.modulePieArr.length > 0) ? _c('el-col', {
    staticClass: "pie-legend",
    attrs: {
      "span": 10
    }
  }, _vm._l((_vm.modulePieArr), function(leg, index) {
    return _c('div', {
      key: leg.moduleid,
      staticClass: "legend-list"
    }, [_c('span', {
      staticClass: "circle",
      style: ({
        'background': index < _vm.pieColor.length ? _vm.pieColor[index] : (_vm.pieColor[index - _vm.pieColor.length])
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(leg.modulename))])])
  }), 0) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.masg),
      expression: "masg"
    }],
    staticStyle: {
      "height": "50px",
      "text-align": "center",
      "color": "#666",
      "line-height": "20"
    }
  }, [_vm._v(" 暂无数据")])], 1)]), _vm._v(" "), _c('el-col', {
    staticClass: "company-stastics-item right",
    attrs: {
      "span": 11
    }
  }, [_c('header', {
    staticClass: "right-hd",
    staticStyle: {
      "position": "relative",
      "margin-bottom": "15px"
    }
  }, [_c('header', {
    staticClass: "module-title",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._v("登录设备统计")]), _vm._v(" "), _c('el-select', {
    staticClass: "checkName",
    staticStyle: {
      "top": "-8px"
    },
    on: {
      "change": function($event) {
        return _vm.changeTime('getDeviceInfo')
      }
    },
    model: {
      value: (_vm.deviceCount),
      callback: function($$v) {
        _vm.deviceCount = $$v
      },
      expression: "deviceCount"
    }
  }, _vm._l((_vm.times), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.deviceLoading),
      expression: "deviceLoading"
    }],
    staticStyle: {
      "height": "70px"
    },
    attrs: {
      "id": "device-chart"
    }
  })], 1), _vm._v(" "), _c('article', {
    staticClass: "right-bd"
  }, [_c('header', {
    staticClass: "module-title"
  }, [_vm._v("积分统计")]), _vm._v(" "), _c('el-select', {
    staticClass: "checkName",
    on: {
      "change": function($event) {
        return _vm.changeTime('getCompanyMonthPointBrokenLine')
      }
    },
    model: {
      value: (_vm.staTime),
      callback: function($$v) {
        _vm.staTime = $$v
      },
      expression: "staTime"
    }
  }, _vm._l((_vm.times), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.creditLoading),
      expression: "creditLoading"
    }],
    staticStyle: {
      "height": "160px"
    },
    attrs: {
      "id": "creditLine"
    }
  })], 1), _vm._v(" "), _c('footer', {
    staticClass: "right-ft",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('header', {
    staticClass: "module-title"
  }, [_vm._v("积分排行榜")]), _vm._v(" "), _c('div', {
    staticClass: "operate-btn"
  }, [_c('el-button', {
    staticClass: "jf_button",
    on: {
      "click": function($event) {
        return _vm.ranking(1)
      }
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-button', {
    staticClass: "jf_button",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.ranking(2)
      }
    }
  }, [_vm._v("近30天")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "size": "small",
      "type": "daterange",
      "value-format": "yyyy-MM-dd",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    on: {
      "change": _vm.changeDateRange
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.rankLoading),
      expression: "rankLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.values,
      "height": "200"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "排名",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "min-width": "100",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sumpoint",
      "label": "产生积分",
      "min-width": "140",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticStyle: {
      "text-algin": "center"
    },
    attrs: {
      "label": "操作",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "label-credit-queue",
          on: {
            "click": function($event) {
              return _vm.handlePie(scope.row.userid, scope.row.name)
            }
          }
        }, [_vm._v("模块使用情况")]), _vm._v(" "), _c('span', {
          staticClass: "label-credit-queue tj",
          on: {
            "click": function($event) {
              return _vm.handleLine(scope.row.userid, scope.row.name)
            }
          }
        }, [_vm._v("积分统计")])]
      }
    }])
  })], 1)], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "model-edit",
    attrs: {
      "title": "选择人员",
      "visible": _vm.personVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.personVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px",
      "border": "1px solid #dfe6ec"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.souchs
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changeSouch
    },
    model: {
      value: (_vm.souch_value),
      callback: function($$v) {
        _vm.souch_value = $$v
      },
      expression: "souch_value"
    }
  }, _vm._l((_vm.optionsSouch), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getUser(1)
      }
    },
    model: {
      value: (_vm.proName),
      callback: function($$v) {
        _vm.proName = $$v
      },
      expression: "proName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getUser(1)
      }
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _vm._l((_vm.dynamicTags), function(tag) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.handleClose(tag)
        }
      }
    }, [_vm._v(" \n          " + _vm._s(tag) + " \n      ")])
  }), _vm._v(" "), (_vm.dynamicTags != '') ? _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.delTags
    }
  }, [_vm._v("清除标签")]) : _vm._e()], 2), _vm._v(" "), _c('el-table', {
    ref: "users",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.users,
      "highlight-current-row": "",
      "header-cell-style": _vm.getRowClass
    },
    on: {
      "current-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.checked),
            expression: "scope.row.checked"
          }],
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": Array.isArray(scope.row.checked) ? _vm._i(scope.row.checked, null) > -1 : (scope.row.checked)
          },
          on: {
            "change": [function($event) {
              var $$a = scope.row.checked,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.$set(scope.row, "checked", $$a.concat([$$v])))
                } else {
                  $$i > -1 && (_vm.$set(scope.row, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                }
              } else {
                _vm.$set(scope.row, "checked", $$c)
              }
            }, _vm.changeFun]
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "账号",
      "min-width": "130",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "min-width": "100",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "point",
      "label": "积分",
      "min-width": "120",
      "show-overflow-tooltip": ""
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "border": "1px solid #dfe6ec",
      "margin-top": "0"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": " prev, pager, next",
      "current-page": _vm.pageNumber2,
      "page-size": _vm.pageSize2,
      "total": _vm.total2
    },
    on: {
      "current-change": _vm.handleCurrentChange2
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.personVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.userSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "model-edit",
    attrs: {
      "title": "近30天模块使用",
      "visible": _vm.pieVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.pieVisible = $event
      }
    }
  }, [_c('span', {
    staticStyle: {
      "position": "absolute",
      "left": "30px",
      "top": "60px"
    }
  }, [_vm._v("当前人员 : " + _vm._s(_vm.pieName))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "360px"
    },
    attrs: {
      "id": "echartBT2"
    }
  })]), _vm._v(" "), _c('el-dialog', {
    staticClass: "model-edit",
    attrs: {
      "title": "近30天积分统计",
      "visible": _vm.lineVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.lineVisible = $event
      }
    }
  }, [_c('span', {
    staticStyle: {
      "position": "absolute",
      "left": "30px",
      "top": "60px"
    }
  }, [_vm._v("当前人员 : " + _vm._s(_vm.lineName))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "360px"
    },
    attrs: {
      "id": "echartZXT2"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5aa957bf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/administrator/companys/static.vue
// module id = 1802
// module chunks = 9